import * as i0 from '@angular/core';
import { EventEmitter, Directive, Output } from '@angular/core';
let TuiEditorImagePreview = /*#__PURE__*/(() => {
  class TuiEditorImagePreview {
    constructor() {
      this.imagePreview = new EventEmitter();
    }
    click(target) {
      if (target instanceof HTMLImageElement) {
        this.imagePreview.emit(target);
      }
    }
    static {
      this.ɵfac = function TuiEditorImagePreview_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TuiEditorImagePreview)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: TuiEditorImagePreview,
        selectors: [["tui-editor-socket", "imagePreview", ""]],
        hostAttrs: [1, "_preview-image"],
        hostBindings: function TuiEditorImagePreview_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("click", function TuiEditorImagePreview_click_HostBindingHandler($event) {
              return ctx.click($event.target);
            });
          }
        },
        outputs: {
          imagePreview: "imagePreview"
        }
      });
    }
  }
  return TuiEditorImagePreview;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { TuiEditorImagePreview };
